const throttle = (fn, time) => {
	let timeout = null;
	return function () {
		if (timeout) {
			return;
		}
		const context = this;
		const args = arguments;
		const later = () => {
			fn.call(context, ...args);
			timeout = null;
		};
		timeout = setTimeout(later, time);
	};
};

class StickyContainerController {
	constructor(element) {
		this.container = element;
		this.init();
	}

	init() {
		this.bindEvents();
		this.updateHeight();
	}

	bindEvents() {
		const throttledUpdate = throttle(this.updateHeight.bind(this), 150);
		this.observer = new ResizeObserver(throttledUpdate);
		this.observer.observe(this.container);
	}

	updateHeight() {
		const height = this.container.offsetHeight;
		this.container.style.setProperty(
			'--sticky-element-height',
			`${height}px`
		);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll(
		'.wp-block-improntad-blocks-sticky-container'
	);
	containers.forEach((container) => new StickyContainerController(container));
});
